import React from 'react';
import { Popover } from 'react-tiny-popover';
import { Box, Typography } from '@mui/material';
import { HolidaysType } from 'src/constants/calendar';
import { dayOffColor, holidayColor, workingTimeColor } from 'src/constants/colors';
import { DaysOffMenuIcon, HolidaysMenuIcon, TooltipBackground, TooltipCalendarClockIcon } from 'src/Icons';

import { BottomSection } from './components';

interface TooltipProps {
  isOpen: boolean;
  onClose: () => void;
  day: any;
  children: any;
  workTimePeriod: any;
  dayOffPeriod: any;
  holidayPeriod: any;
}

export function Tooltip({
  isOpen,
  onClose,
  day,
  workTimePeriod,
  dayOffPeriod,
  holidayPeriod,
  children,
}: TooltipProps) {
  const displayDay = day.date();
  const formattedTooltipWeekday = `${day.format('ddd')}`;
  const formattedTooltipDate = `${displayDay <= 9 ? '0' : ''}${displayDay}`;

  const { selectedColor, bottomText, Icon } = (() => {
    if (holidayPeriod) {
      return {
        Icon: HolidaysMenuIcon,
        selectedColor: holidayColor,
        bottomText: holidayPeriod?.type === HolidaysType.Free ? 'Free day' : 'Shortened day',
      };
    } else if (dayOffPeriod) {
      return {
        Icon: DaysOffMenuIcon,
        selectedColor: dayOffColor,
        bottomText: 'Day-off',
      };
    }

    return {
      Icon: TooltipCalendarClockIcon,
      selectedColor: workingTimeColor,
      bottomText: `${workTimePeriod?.from}-${workTimePeriod?.to}`,
    }
  })();

  return (
    <Popover
      isOpen={isOpen}
      containerStyle={{
        zIndex: '5000',
        overflow: 'hidden',
      }}
      positions={['bottom']}
      padding={-24}
      reposition={false}
      onClickOutside={onClose}
      content={() => (
        <Box
          sx={{
            width: '135px',
            height: '115px',
            display: 'flex',
            flexDirection: 'column',
            fontSize: '167px',
            color: selectedColor,
            cursor: 'default',
            userSelect: 'none',
          }}>
          <TooltipBackground style={{
            position: 'absolute',
            top: '-22px',
            left: '-16px',
          }} fontSize="inherit"/>

          <Box sx={{
            display: 'flex',
            justifyContent: 'space-around',
          }}>
            <Box sx={{
              flex: 1,
              position: 'relative',
            }} onClick={onClose} />
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '24px',
              height: '24px',
              position: 'relative',
            }}>
              <Typography sx={{
                fontWeight: '500',
                color: selectedColor,
                fontSize: '11px',
              }}>
                {displayDay}
              </Typography>
            </Box>
            <Box sx={{
              flex: 1,
              position: 'relative',
            }} onClick={onClose} />
          </Box>
          <Box style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            fontSize: '11px',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          }}>
            <Box>
              <Typography sx={{
                fontSize: '14px',
                fontWeight: '400',
                color: '#080808',
                textTransform: 'uppercase',
                textAlign: 'center',
              }}>
                {formattedTooltipWeekday}
              </Typography>
              <Typography sx={{
                fontSize: '22px',
                fontWeight: '500',
                color: '#333333',
                marginBottom: '4px',
                textAlign: 'center',
              }}>
                {formattedTooltipDate}
              </Typography>
            </Box>
            <BottomSection
              Icon={Icon}
              color={selectedColor}
              text={bottomText}
            />
          </Box>
        </Box>
      )}
    >
      {children}
    </Popover>
  );
}
